import { render, staticRenderFns } from "./my-schools.vue?vue&type=template&id=3acb3b2a"
import script from "./my-schools.vue?vue&type=script&lang=js"
export * from "./my-schools.vue?vue&type=script&lang=js"
import style0 from "./my-schools.vue?vue&type=style&index=0&id=3acb3b2a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports